import React, { useState } from "react";
import moment from "moment";
import { Col, Row, Alert, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { Query } from "react-apollo";
import {
  faPencil,
  faPlugCirclePlus,
  faChevronRight,
  faRefresh
} from "@fortawesome/free-solid-svg-icons";
import { formatNumber, crispSendMessage } from "../generic";
import { getComptes } from "../../api/queries/comptes.queries";
import { useAuthState } from "../Context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PengeAlert from "../components/PengeAlert";
import AddAccountButton from "./AddAccountButton";
import Loader from "../components/Loader";

function AccountType({ type }) {
  let display = type;

  switch (type) {
    default:

    case "datasource":
      display = "Compte manuel";
      break;
    case "checking":
      display = "Compte courant";
      break;
    case "savings":
      display = "Compte épargne";
      break;
    case "brokerage":
      display = "Compte titre";
      break;
    case "loan":
      display = "Compte Crédit";
      break;
    case "card":
      display = "Compte carte";
      break;
    case "shared_saving_plan":
      display = "PEA";
      break;
    case "pending":
      display = "Compte virtuel";
      break;
    case "life_insurance":
      display = "Assurance vie";
      break;
    case "special":
      display = "Compte temporaire";
      break;
    case "unknown":
      display = "Compte inconnu";
      break;
  }
  return <span className="accountType">{display}</span>;
}

function AccountUpdate({ date }) {
  const formattedDate = moment
    .utc(date)
    .locale("fr-fr")
    .format("dddd D/MM/Y à H:MM")
    .toLowerCase();

  return <span className="retrievalDate">{formattedDate}</span>;
}

function DeleteAccount({ identifiant, handleDeleteAccount, refetch }) {
  return (
    <span
      onClick={() => handleDeleteAccount(identifiant, refetch)}
      className="removeAccount"
    >
      Supprimer
    </span>
  );
}

function AccountBalance({ balance, syncing, type }) {
  let displayBalance = (
    <span className={`balance ${balance > 0 ? "positive" : "negative"}`}>
      {formatNumber(balance, "€")}
    </span>
  );

  if (syncing && type !== "datasource")
    displayBalance = (
      <span className="balance">En cours de synchronisation...</span>
    );

  return displayBalance;
}

function BankName({ banque, syncing, type }) {
  if (type === "datasource")
    return <span className="bank">Source de données manuelle</span>;

  if (syncing) return <span className="bank">&nbsp;</span>;

  return <span className="bank">{banque}</span>;
}

function AccountItem(props) {
  const [hovering, setHovering] = useState(false);
  const [hoveringCheckbox, setHoveringCheckbox] = useState(false);
  const [isEditingField, setIsEditingField] = useState(null); // correspond à un identfiant de compte, sinon null
  const [editingFieldValue, setEditingFieldValue] = useState(""); // correspond au contenu
  const navigate = useNavigate();

  const {
    addButton = false,
    configurable = false,
    names = false,
    clickAction,
    checkedCondition = "active",
    showWelcomingPrompt = false,
    hideInactive = false,
    utilisateurId,
    compte = {},
    handleDeleteAccount,
    handleForceRefreshAccount,
    refetch
  } = props;

  let loader = (
    <span
      className="retrievingAccount"
      style={{ float: "right", paddingRight: "10px" }}
    >
      {" "}
      <FontAwesomeIcon icon={faRefresh} size="sm" className="fa-spin" />
    </span>
  );

  function renderCheckboxes(checked, identifiant, refetchAction) {
    return (
      <div className="checkboxWrapper">
        <a
          className={`checkbox ${checked ? "checked" : ""}`}
          onClick={() =>
            clickAction({ utilisateurId, identifiant, refetchAction })
          }
        ></a>
      </div>
    );
  }

  function renderName(compte) {
    let editFeatures;
    const displayName = compte.label || compte.name || "Compte sans nom";

    if (configurable && names)
      editFeatures = (
        <span
          className="btn btn-xs"
          style={{ float: "right" }}
          onClick={() => {
            setIsEditingField(compte.identifiant);
            setEditingFieldValue(displayName);
          }}
        >
          {" "}
          <FontAwesomeIcon icon={faPencil} size="sm" />
        </span>
      );

    if (configurable && names && isEditingField === compte.identifiant)
      return (
        <span className="title">
          <input
            className="editableInput"
            type="text"
            value={editingFieldValue}
          />
        </span>
      );

    return <span className="title">{displayName}</span>;
  }

  function handleViewTransactions(identifiant) {
    navigate(`/transactions/${identifiant}`);
  }

  // Si on a une url + un code 1010, on sort la panoplie du renew
  const renewIssue = !!(
    compte.bridgeRenewUrl && parseInt(compte.syncStatus, 10) === 1010
  );
  let renewButton = null;

  if (renewIssue) {
    renewButton = (
      <a
        href={compte.bridgeRenewUrl}
        className="btn btn-xs btn-warning"
        style={{
          float: "right",
          zIndex: 100,
          position: "relative"
        }}
      >
        <FontAwesomeIcon icon={faRefresh} size="sm" /> Renouveler l'autorisation
      </a>
    );
  }

  return (
    <li
      className={`account ${renewIssue ? "fadeOut " : ""}${
        hovering && !renewIssue ? "hovering" : ""
      }`}
      onMouseMove={() => !configurable && setHovering(true)}
      onMouseOut={() => !configurable && setHovering(false)}
      onClick={() => {
        if (hovering && !renewIssue && !hoveringCheckbox && !configurable)
          handleViewTransactions(compte.identifiant);
      }}
    >
      {renewButton}
      {configurable ? (
        <div
          onMouseMove={() => setHoveringCheckbox(true)}
          onMouseOut={() => setHoveringCheckbox(false)}
        >
          {renderCheckboxes(
            compte[checkedCondition],
            compte.identifiant,
            refetch
          )}
        </div>
      ) : null}
      {renderName(compte)}
      <BankName {...compte} />
      <AccountBalance {...compte} />
      {configurable && (
        <DeleteAccount
          identifiant={compte.identifiant}
          handleDeleteAccount={handleDeleteAccount}
          refetch={refetch}
        />
      )}
      <AccountType type={compte.type} />
      <AccountUpdate date={compte.retrievalDate} />
      {compte.retrievalDate === null && compte.sheetsActive ? loader : null}
      <a
        className="viewTransactions"
        onClick={() => handleViewTransactions(compte.identifiant)}
      >
        <FontAwesomeIcon icon={faChevronRight} size="2x" />
      </a>
    </li>
  );
}

function NoAccountsAlert({ showWelcomingPrompt }) {
  let welcomingPrompt = showWelcomingPrompt ? (
    <>
      <h1>Bienvenue sur Penge !</h1>
      <p>
        C’est votre première fois sur Penge. Si vous avez besoin d'aide,
        n'hésitez pas à{" "}
        <a
          href="#"
          className="callToActionLink"
          onClick={() => crispSendMessage("test")}
        >
          nous contacter
        </a>
        .
      </p>
    </>
  ) : null;

  return (
    <>
      <PengeAlert text="Vous n'avez encore connecté aucun compte">
        <AddAccountButton />
      </PengeAlert>
      {welcomingPrompt}
    </>
  );
}

function AddOtherAccounts(addButton) {
  if (!addButton) return null;
  return <AddAccountButton />;
}

function AccountList(props) {
  const authContext = useAuthState(); //read user de

  const {
    addButton = false,
    configurable = false,
    names = false,
    clickAction,
    checkedCondition = "active",
    showWelcomingPrompt = true,
    hideInactive = false
  } = props;

  const { userDetails = {} } = authContext;
  const { id: utilisateurId, login, email, token } = userDetails;

  if (!utilisateurId) return;

  return (
    <Query
      query={getComptes}
      variables={{ utilisateurId }}
      fetchPolicy="no-cache"
    >
      {({ loading, error, data = {}, refetch }) => {
        if (loading) return <Loader />;
        if (error) return "Erreur !";

        const { getComptes = [] } = data;

        if (!getComptes.length)
          return <NoAccountsAlert showWelcomingPrompt={showWelcomingPrompt} />;

        return (
          <ul>
            {AddOtherAccounts(addButton)}
            {getComptes.map(compte => {
              if (hideInactive && !compte.active) return null;

              return (
                <AccountItem
                  utilisateurId={utilisateurId}
                  compte={compte}
                  refetch={refetch}
                  {...props}
                />
              );
            })}
          </ul>
        );
      }}
    </Query>
  );
}
export default AccountList;
